import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLaunchDarklyStore = defineStore('launchDarklyStore', () => {
  const LDFlags = ref({});

  return { LDFlags };
});
